/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Rating } from './rating';


export interface FeedbackResponse { 
    id: string;
    creatorId?: string;
    serviceProviderName?: string;
    serviceProviderEmailAddress?: string;
    rating1: Rating;
    rating1Name?: string;
    rating2: Rating;
    rating2Name?: string;
    rating3: Rating;
    rating3Name?: string;
    rating4: Rating;
    rating4Name?: string;
    rating5: Rating;
    rating5Name?: string;
    comment?: string;
    dateCreated: Date;
}
